module.exports = __webpack_public_path__ + "static/CVS-Catch-E-cigarettes-Risks-HUMANITIES-ANIMATIONS-87a7d081bad8003c0357159545548b82.pdf";